const listDefaults = {
  data () {
    return {
      first: true,
      dialog: {
        view: false,
        save: false,
        selected: this.default
      }
    }
  },

  methods: {
    newDialog () {
      this.dialog.selected = Object.assign({}, { ...this.default })
      this.dialog.view = false
      this.dialog.save = true
    },

    viewDialog (item) {
      this.dialog.selected = item
      this.dialog.save = false
      this.dialog.view = true
    },

    editDialog (item) {
      /* const item_ = Object.entries(item)
      const item__ = {}
      item_.forEach((value_, key_) => {
        key_ = value_[0]
        value_ = value_[1]
        const blank_ = []
        item__[key_] = (value_ && value_.constructor.name === 'Array' ? blank_.concat(value_) : value_)
      })
      this.dialog.selected = Object.assign({}, item__) */
      this.dialog.selected = Object.assign({}, { ...item })
      this.dialog.view = false
      this.dialog.save = true
    },

    resetDialog () {
      this.dialog.selected = this.default
      this.dialog.view = false
      this.dialog.save = false
    },

    onCloseView (val) {
      this.dialog.view = !val
    },

    onCloseSave (val) {
      this.dialog.save = !val
    }
  }
}

export default listDefaults
